import type { ViewerComponent } from 'feature-components'
import type { IExternalComponentLoader, IExternalComponentProps } from '../types'
import { ExternalComponentData } from '../types'

export const loadComponentAndUpdateProps = async (
	externalComponentLoader: IExternalComponentLoader,
	comp: ViewerComponent<IExternalComponentProps>,
	compData: ExternalComponentData,
	disableBYOC: boolean,
	onError: (e: Error) => void,
	cacheKillerCounter?: number
) => {
	const nullifyComponentAndReport = (e: Error) => {
		comp.updateProps({ Component: null, error: e })
		onError(e)
	}

	const compProps = comp.getProps().compProps
	const { url, isTrusted, importKey, appDefId } = compData

	if (disableBYOC || !url) {
		comp.updateProps({ Component: null })
		return
	}
	try {
		const Component = await externalComponentLoader.loadComponent({
			compProps,
			url,
			isTrusted,
			importKey,
			id: comp.id,
			onError: nullifyComponentAndReport,
			cacheKillerCounter,
			appDefId,
		})

		comp.updateProps({ Component })
	} catch (e) {
		nullifyComponentAndReport(e)
	}
}
